import { Box, styled, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import * as React from 'react';
import { colors } from '../styles/colors';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { content } from '../content/content';
import { useMagazines } from '../hooks/useMagazines';
import { OutboundLink } from 'gatsby-plugin-google-gtag';

type CampaignCardProps = {
  campaign: Queries.CampaignDataFragment;
  magazineName?: string;
  displayMagazineName: boolean;
};

const GridItem = styled(Grid2)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
}));

const CTAButton = styled(Box)(() => ({
  width: '100%',
  minWidth: '215px',
  backgroundColor: colors.primaryGreen,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: colors.secondaryGreen,
  },
}));

const CardWrapper = styled(Box)(() => ({
  border: '1px solid',
  borderColor: colors.lightGrey,
  borderRadius: 0,
  userSelect: 'none',
  cursor: 'pointer',
  transition: 'all 0.15s ease-in-out',
  '&:hover': {
    scale: '1.01',
    borderColor: colors.secondaryGreen,
  },
}));

const StyledOutboundLink = styled(OutboundLink)(() => ({
  textDecoration: 'none',
  color: 'unset',
}));

const CampaignCard: React.FC<CampaignCardProps> = ({ campaign, displayMagazineName, magazineName }) => {
  const image = getImage(campaign.localImage as any) ?? getImage(campaign.localLogoImage as any);
  const { name } = useMagazines({ magazineId: campaign.magazineId ?? '' })[0] ?? { name: campaign.displayName };
  return (
    <CardWrapper mb={2} p={3}>
      <StyledOutboundLink
        href={magazineName ? `${campaign.trackingUrl!}${magazineName.replace(' ', '+').toLowerCase()}` : campaign.trackingUrl!}
        target="_blank"
        rel="noopener norefferer"
      >
        <Grid2 container rowSpacing={3} columnSpacing={7}>
          <GridItem xs={12} md={'auto'}>
            <GatsbyImage image={image!} alt={`${campaign.description} ${content.components.campaignCard.imageAltSuffix}`} />
          </GridItem>
          <GridItem xs>
            {displayMagazineName && <Typography variant="h6">{name}</Typography>}
            <Typography textAlign={'center'} color="text.secondary">
              {campaign.description}
            </Typography>
          </GridItem>
          <GridItem xs={12} md={'auto'}>
            <CTAButton p={2} borderRadius={1}>
              <Typography fontSize={17} fontWeight={'bold'} color={'white'}>
                {content.components.campaignCard.CTA}
              </Typography>
            </CTAButton>
          </GridItem>
        </Grid2>
      </StyledOutboundLink>
    </CardWrapper>
  );
};

export default CampaignCard;

